import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [plan, setPlan] = useState(null);

  const loadPlan = () => api.get("/billing/my-plan").then((p) => setPlan(p.data)).catch(() => setPlan(null));

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => { setUser(r.data); loadPlan(); })
      .catch(() => setUser(false));
  }, []);

  // Se un'altra scheda cambia account (login/logout), questa si ricarica:
  // evita lo stato "misto" (nome di un tenant, dati dell'altro).
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "dishenda_token" && e.newValue !== e.oldValue) window.location.reload();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("dishenda_token", data.token);
    setUser(data.user);
    loadPlan();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("dishenda_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, plan, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
